<template>
    <div>
        <PartnerHeader :img_header="header_image" header="ข้อมูลร้านค้า" link_back=""/>
        <MenuMember/>
        <CustomerDashboard/>
    </div>
</template>

<script>
import PartnerHeader from "@/components/admin/manage_pos/partner_store_setting/menu_partner_store/PartnerHeader";
import HeaderImage from "@/assets/store.png";
// import MenuMember from '@/components/admin/member/menumember/MenuMember.vue'
import CustomerDashboard from '@/components/admin/member/customer/CustomerDashboard.vue'

export default {
    name:'customer',
    components:{
        // MenuMember,
        PartnerHeader,
        CustomerDashboard,
    },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>